import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";

function PoliticaCard() {
  // Stato per tracciare quale riga specifica è aperta
  const [activeId, setActiveId] = useState(null);

  const toggle = (id) => {
    setActiveId(activeId === id ? null : id);
  };

  // Componente per gestire la singola riga cliccabile
  const RigaInterattiva = ({ id, imgLink, children }) => {
    const isOpen = activeId === id;

    if (isOpen) {
      // MOSTRA IMMAGINE
      return (
        <div 
          onClick={() => toggle(id)} 
          style={{ cursor: "pointer", textAlign: "center", marginBottom: "10px", animation: "fadeIn 0.5s" }}
        >
          <img 
            src={imgLink} 
            alt="Certificato" 
            style={{ 
              maxWidth: "100%", 
              maxHeight: "300px",
              borderRadius: "8px", 
              boxShadow: "0 4px 15px rgba(0,0,0,0.5)" 
            }} 
          />
          <div style={{ fontSize: "0.8rem", color: "#ccc" }}>(Clicca per chiudere)</div>
        </div>
      );
    }

    // MOSTRA TESTO (Cliccabile)
    return (
      <div 
        onClick={() => toggle(id)}
        style={{ cursor: "pointer", textAlign: "center" }}
        title="Clicca per vedere l'attestato"
      >
        {children}
      </div>
    );
  };

  // Stile per i titoli statici
  const headerStyle = { fontSize: "1.5em", textAlign: "center", color: "#C770F0" };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col md={10}>
        <blockquote className="blockquote mb-0">

          {/* --- PARTI STATICHE --- */}
          
          <h2 style={headerStyle}>
            Equilibrium Party <img src="https://i.imgur.com/gbwgSDj.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <p style={{ textAlign: "center" }}>● Vice Presidente</p>
          <br />

          <h2 style={headerStyle}>
            Vox Aequilibrium <img src="https://i.imgur.com/4EBTMCe.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <p style={{ textAlign: "center" }}>● Attualmente Praeses Dictum (Presidente Terziario)</p>
          <br /><br />

          <h2 style={headerStyle}>
            Governo Montfort I <img src="https://i.imgur.com/FHn7HuD.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <p style={{ textAlign: "center" }}>● Consigliere BCN</p>
          <br />

          <h2 style={headerStyle}>
            Governo Kurubulut Ver III <img src="https://i.imgur.com/geZFfyz.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <p style={{ textAlign: "center" }}>● Consigliere BCN</p>
          <br />

          {/* --- PARTI INTERATTIVE --- */}

          {/* 1. GOVERNO LEROUX I (Ministro interattivo) */}
          <h2 style={headerStyle}>
            Governo Leroux I <img src="https://i.imgur.com/mr9Qwtm.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <RigaInterattiva 
            id="leroux_ministro" 
            imgLink="https://i.imgur.com/m8kX0fr.png"
          >
            <p>● <span style={{textDecoration: "underline", fontWeight: "bold"}}>Ministro dell'Economia e Lavoro (clicca per visualizzare il distintivo)</span></p>
          </RigaInterattiva>
          <br />

          {/* 2. GOVERNO EHRMANTRAUT I (Due righe interattive separate) */}
          <h2 style={headerStyle}>
            Governo Ehrmantraut I <img src="https://i.imgur.com/L4Z9SwX.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          
          <RigaInterattiva 
            id="ehr_sotto" 
            imgLink="https://i.imgur.com/58kKT1Y.png"
          >
            <p style={{marginBottom: "0"}}>● <span style={{textDecoration: "underline", fontWeight: "bold"}}>Sottosegretario alla Vice Presidenza di Stato (clicca per visualizzare il distintivo)</span></p>
          </RigaInterattiva>

          <RigaInterattiva 
            id="ehr_ministro" 
            imgLink="https://i.imgur.com/kRP4cGW.png"
          >
            <p>● <span style={{textDecoration: "underline", fontWeight: "bold"}}>Ministro dell'Economia e Lavoro (clicca per visualizzare il distintivo)</span></p>
          </RigaInterattiva>
          <br />

          {/* 3. GOVERNO BEEZY II (Vice Presidente interattivo) */}
          <h2 style={headerStyle}>
            Governo Beezy II <img src="https://i.imgur.com/sHXsq7C.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <RigaInterattiva 
            id="beezy_vice" 
            imgLink="https://i.imgur.com/wennU3P.png"
          >
            <p>● <span style={{textDecoration: "underline", fontWeight: "bold"}}>Vice Presidente di Stato (clicca per visualizzare il distintivo)</span></p>
          </RigaInterattiva>
          <br />

          {/* --- DISEGNI DI LEGGE (STATICI) --- */}
          <h2 style={headerStyle}>Disegni di Legge</h2>
          <p style={{ textAlign: "center" }}>
            ● <a href="https://docs.google.com/document/d/1KQHEUvm5NFcvwiN505Rh1tnsfZvZby_Fr50-pu559SI/edit?tab=t.0#heading=h.3q7qkrtnqzps" target="_blank">Legge di Bilancio</a><br />
            ● <a href="https://docs.google.com/document/d/19u_zv63vuNEWRnGZO0COi11MkYtsF93ZURU1HGV_5JY/edit?tab=t.0#heading=h.v1di10a13ncc" target="_blank">Regolamentazione Ordini di Stato</a><br />
            ● <a href="https://docs.google.com/document/d/1JZWW3-J5Woj2Y5JY0tu-eOMVApkK1EYd9AxGpM9zZuQ/edit?tab=t.0" target="_blank">Revisione dei Bonus Statali</a><br />
            ● <a href="https://docs.google.com/document/d/1uWjwPjjlW84LZ9JDcOIroS02d2RZ3-YGGyaJKEsHE1U/edit?tab=t.0" target="_blank">Revisione della Tredicesima</a><br />
            ● <a href="https://docs.google.com/document/d/1Xt8SraoJsTx31I3G4izj3Dx3UsiyLJzVWCGKBoMblkA/edit?tab=t.0" target="_blank">Regolamentazione Import Merce a Magazzino</a><br />
            ● <a href="https://docs.google.com/document/d/1j-Wu_2-PI0vjMdWxcUQCUBtVU5DnegwaoMHD2KZ1BU0/edit?tab=t.0" target="_blank">Riequilibramento dei Conti di Stato</a><br />
            ● <a href="https://docs.google.com/document/d/1KKG9QKygTUKGOTF30Qe24zbBtENTUcyHO0kRk5F1AYg/edit?tab=t.0" target="_blank">Modifica Costituzione della BCN</a><br />
            ● <a href="https://docs.google.com/document/d/1JzECTvKly_RbWpBvnSDEhFyYG5tkOjWOSVwBtkIIXOA/edit?tab=t.0#heading=h.wij0kn3daur8" target="_blank">Revisione Economica sulle Tasse</a><br />
            ● <a href="https://docs.google.com/document/d/1O14E--U_6mFcaoKOH4w6hkVSDlF_EDSxm4sAQBtEiLU/edit?tab=t.0" target="_blank">Riparazione delle Infrastrutture Pubbliche</a><br />
            ● <a href="https://docs.google.com/spreadsheets/d/1--QqHG9GIfUobT6d-5RaiOCEn-2WjxoRDC0A2z1V_18/edit?usp=sharing" target="_blank">Aggiornamento del Registro sull'Inflazione per l'annata 2023-24 e 2024-25</a>
          </p>
          <br />

          {/* 4. ONORIFICENZA (Cavaliere interattivo) */}
          <h2 style={headerStyle}>
            Onorificenza <img src="https://i.imgur.com/1FXmj2K.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          <RigaInterattiva 
            id="onorificenza_cavaliere" 
            imgLink="https://i.imgur.com/7ZZ8bkk.png"
          >
            <p>
              ● Medaglia d'Oro di <span className="purple" style={{textDecoration: "underline", fontWeight: "bold"}}>Cavaliere del Lavoro (clicca per visualizzare)</span> nell'ambito della <span className="purple">Ricerca e Cultura</span>, conferita il 1° maggio 2025 dal XXIX° Presidente di Stato <span className="purple">Andrea Romero</span>
            </p>
          </RigaInterattiva>

          {/* 5. RICONOSCIMENTI (Buon Cittadino e Fotografo interattivi) */}
          <h2 style={headerStyle}>
            Riconoscimenti <img src="https://i.imgur.com/Fxtqb6w.png" style={{ height: "50px"}} alt="logo"/>
          </h2>
          
          <RigaInterattiva 
            id="ricon_cittadino" 
            imgLink="https://i.imgur.com/4dH1xDx.png"
          >
             <p style={{marginBottom: "0"}}>● Tessera del <span className="purple" style={{textDecoration: "underline", fontWeight: "bold"}}>Buon Cittadino (clicca per visualizzare)</span> conferito il 06/09/2025</p>
          </RigaInterattiva>

          <RigaInterattiva 
            id="ricon_fotografo" 
            imgLink="https://i.imgur.com/UrXLiJe.png"
          >
            <p>● 2° Classificato al contest <span className="purple" style={{textDecoration: "underline", fontWeight: "bold"}}>"PhotoShooting" (clicca per visualizzare)</span> organizzato dalla <span className="purple">Vodafone</span> il 06/09/2022</p>
          </RigaInterattiva>
          <br />

        </blockquote>
      </Col>
    </Row>
  );
}

export default PoliticaCard;